import {
  setMessageVisibility,
  getOwnerData,
  getQuotation,
  getIsOperatorFromSelector,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';
import {
  isPersonalDataRedesignActive,
  isPersonalDataTwoAdvantagesView,
} from 'app/shared/helpers/personalDataViewByDevice';

const ownerObfuscation = {
  showOwnerNameObfuscatedMessage(initialRun?: boolean) {
    const { name = '' } = getOwnerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: name,
      initialRun,
      messageKey: MessagesEnum.OwnerNameObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataRedesignActive(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'owner',
        field: 'name',
      },
    });
  },
  showOwnerLastNameObfuscatedMessage(initialRun?: boolean) {
    const { lastName = '' } = getOwnerData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: lastName,
      initialRun,
      messageKey: MessagesEnum.OwnerLastNameObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataRedesignActive(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'owner',
        field: 'lastName',
      },
    });
  },
  showOwnerPeselObfuscatedMessage(initialRun?: boolean) {
    const pesel = `${getOwnerData().pesel}`;
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: pesel,
      initialRun,
      messageKey: MessagesEnum.OwnerPeselObfuscated,
      formName: FormsEnum.CalculationForm,
      quotation,
      isOperator,
      forceHideMessage: isPersonalDataTwoAdvantagesView(),
      resetTarget: {
        type: 'person',
        trackedPerson: 'owner',
        field: 'peselNumber',
      },
    });
  },
  showOwnerFamilyNameObfuscatedMessage(initialRun?: boolean) {
    const { familyName } = getOwnerData();

    const showObfuscatedMessage = checkIsDataObfuscated(familyName, initialRun);

    setMessageVisibility({
      key: MessagesEnum.OwnerFamilyNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CalculationForm,
    });
  },
};

export default ownerObfuscation;
